import { useGetApiV1ClassroomdisciplineSharedCompanies } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de empresas por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de empresa do filtro "Empresa" da listagem de Séries. Consome
 * o lookup `classroomdiscipline/shared/companies` do Kubb — mesmo endpoint
 * usado por `exam-management`/`class-module-management` (`CompanyAutocomplete`),
 * duplicado aqui por regra de FSD (features não se importam lateralmente).
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useCompanySearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedCompanies(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
